import React, { ReactNode } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

import { useLoggedIn } from '../../hooks/apollo/useLoggedIn';
import { commonRoutes } from '../constants';

export interface PrivateRouteProps extends RouteProps {
    children: ReactNode;
}

export const PrivateRoute = ({ children, ...rest }: PrivateRouteProps) => {
    // A wrapper for <Route> that redirects to the login screen if you're not yet authenticated
    const isLoggedIn = useLoggedIn();

    return (
        <Route
            {...rest}
            render={({ location }) =>
                isLoggedIn ? (
                    <>{children}</>
                ) : (
                    <Redirect
                        to={{
                            pathname: `/${commonRoutes.LOGIN}`,
                            state: { from: location },
                        }}
                    />
                )
            }
        />
    );
};
